// extracted by mini-css-extract-plugin
export default {"BaseCell":"repo-searcher-module__BaseCell--D8MNp","Box":"repo-searcher-module__Box--Gc1CF"};